import React, { ReactNode, useEffect, useRef, useState } from "react";
import styled from "styled-components";
import "./";
import LabelText from "../LabelText";
import ChipComponent from "../Chip";
import { IPlayerCardDetail } from "../../types/IPlayerCardDetail";
import { useNavigate } from "react-router-dom";
import More from "../../assets/icons/More.png";
import LabelNumber from "../../styled-components/LabelNumber";
import noImageplayer from "../../assets/icons/noImagePlayer.svg";
import Spyglass from "../../assets/icons/Spyglass.png";
import PlayerIcon from "../../assets/icons/Profile.png";
import CloseIcon from "@mui/icons-material/Close";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import Bookmark from "../../assets/icons/Bookmark.png";
import { useAuth } from "../../contexts/AuthContext";
import { useLoading } from "../../contexts/LoadingContext";
import { useNotification } from "../../contexts/NotificationContext";
import { addUpdateSortListData } from "../../components/PlayerComparison/addOrUpdateSortList";
import RemoveIcon from "../../assets/icons/remove.png";
import Tick from "../../assets/icons/Tick.png";
import VisibleOFF from "../../assets/icons/VisibleOFF.png";
import { ModuleSpinner } from "../LoadingSpinner/ModuleSpinner";
import { InfoOutlined } from "@mui/icons-material";
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
import PWNotification from "../../components/PWNotification";
import BookmarkBorderOutlinedIcon from "@mui/icons-material/BookmarkBorderOutlined";
import { useNewPlayerShortlistContext } from "../../contexts/NewPlayerShortlistContext";

const PlayerCard = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px 16px 14px 16px;
  border-radius: 8px;
  // width: calc(25% - 24px);
  margin: 0px 12px 15px;
  border: 1px solid #dadada;
  background: ${({ theme }) => theme.playerContentBackground};
  @media (max-width: 1700px) {
    width: calc(33.3% - 65px);
  }
  @media (max-width: 1365px) {
    width: calc(50% - 65px);
  }
  @media (max-width: 1200px) {
    width: calc(50% - 65px);
  }
  @media (max-width: 991px) {
    width: calc(100% - 65px);
  }
`;

const PlayerHeader = styled.div`
  display: flex;
  flex-shrink: 0;
  align-self: stretch;
  padding: 0px 34px;
  justify-content: center;
  margin-bottom: 8px;
  position: relative;

  .playerNumber {
    // position: absolute;
    // right: 0px;
    color: ${({ theme }) => theme.NumberColor};
    text-align: right;
    font-feature-settings: "clig" off, "liga" off;
    /* DM-Mono/Title/Large */
    font-family: "DM Mono";
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px; /* 100% */
    text-transform: uppercase;
  }

  .selected-player-in-card {
    position: absolute;
    left: 0px;
  }
`;

const PlayerAvatar = styled.div<{ backgroundImage: string }>`
  width: 155px;
  height: 155px;
  flex-shrink: 0;
  cursor: pointer;
  background: url(${(props) => props.backgroundImage}) 0% / cover no-repeat;
`;

const PlayerNameHeader = styled.div`
  display: contents;
  cursor: pointer;
  .squad-number {
    justify-content: space-between;
    display: flex;
    align-items: center;
    align-self: stretch;
  }
  .position-text {
    cursor: default;
    display: flex;
    justify-content: flex-start;
    .expected-psotion {
      margin-left: 4px;
    }
  }
  & .drawer-title {
    height: 100%;
    font-family: "Aeonik";
    font-weight: 700;
    font-size: 32px;
    line-height: 40px;
    @media (max-width: 1366px) {
      font-size: 24px;
    }
  }
`;

const CardInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  height: 100%;
  justify-content: space-between;
`;

const PlayerCardFooter = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 10px;
`;

interface ClubCardProps {
  clubId: number;
  clubName: string;
  leagueName: string;
  clubImageURL: string;
  revenue: string;
  costs: string;
  profitLoss: string;
  debt: string;
  assetsLiabilities: string;
  currentLeaguePosition: number;
  currentExpectedLeaguePosition: number;
  setClubCardID?: React.Dispatch<React.SetStateAction<number>>;
}

const ClubCard: React.FC<ClubCardProps> = ({
  clubId,
  clubName,
  leagueName,
  clubImageURL,
  revenue,
  costs,
  profitLoss,
  debt,
  assetsLiabilities,
  currentLeaguePosition,
  currentExpectedLeaguePosition,
  setClubCardID
}) => {
  const navigate = useNavigate();
  const { loading } = useLoading();
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);
  const goToDetailPage = () => {
    navigate(`/club/${clubId}`);
  };
  return (
    <>
      <PlayerCard className="player-card" onClick={() => setClubCardID!(0)}>
        {loading && <ModuleSpinner />}
        <PlayerHeader>
          <div className="status-avatar-container">
            <PlayerAvatar onClick={() => goToDetailPage()} backgroundImage={clubImageURL ? clubImageURL : noImageplayer} />
          </div>
          <div
            className={`${isMenuOpen && "more-squad-button-clicked "} more-squad-button`}
            onClick={(event) => {
              event.stopPropagation();
              setIsMenuOpen(!isMenuOpen);
            }}
          >
            <img src={More} alt="more-menu" />
          </div>
          {isMenuOpen && (
            <div className="squad-player-menu">
              <LabelNumber className="attack-defense-data">OPTIONS</LabelNumber>
              <div>
                <button onClick={() => goToDetailPage()}>
                  <img src={PlayerIcon} alt="player-profile" />
                  <LabelText className="menu-list">Club Profile</LabelText>
                </button>
                <button
                  onClick={(event) => {
                    event.stopPropagation();
                    setClubCardID!(0);
                  }}
                >
                  <CloseIcon />
                  Close
                </button>
              </div>
            </div>
          )}
        </PlayerHeader>
        <CardInfo>
          <PlayerNameHeader>
            <div className="squad-number">
              <LabelText className="club-given-name" onClick={() => goToDetailPage()}>
                {clubName}
              </LabelText>
            </div>
            <LabelNumber className="position-text">{leagueName}</LabelNumber>
            <LabelNumber className="position-text">League Position : {currentLeaguePosition}<span className="expected-psotion" style={{color: currentLeaguePosition - currentExpectedLeaguePosition === 0 ? "black" : currentLeaguePosition - currentExpectedLeaguePosition > 0 ? "green" : "red"}}>{currentLeaguePosition - currentExpectedLeaguePosition >= 0 && "+"}{currentLeaguePosition - currentExpectedLeaguePosition}</span></LabelNumber>
          </PlayerNameHeader>
          <PlayerCardFooter>
            <div className="squad-atrribute-container">
              <div className="squad-club-attributes">
                <p>REVENUE</p>
                <div className="attribute-value-container">
                  <p>{revenue}</p>
                </div>
              </div>
              <div className="squad-club-attributes">
                <p>COSTS</p>
                <div className="attribute-value-container">
                  <p>{costs}</p>
                </div>
              </div>
              <div className="squad-club-attributes" style={{backgroundColor: profitLoss?.includes("-") ? "#FFC2C2" : "#C9F0B6", border: profitLoss?.includes("-") ? "1px solid #E8B1B1" : "1px solid #B7DAA6"}}>
                <p>PROFIT/LOSS</p>
                <div className="attribute-value-container">
                  <p>{profitLoss}</p>
                </div>
              </div>
              <div className="squad-club-attributes" style={{backgroundColor: debt?.includes("-") ? "#FFC2C2" : "#C9F0B6", border: debt?.includes("-") ? "1px solid #E8B1B1" : "1px solid #B7DAA6"}}>
                <p>DEBT</p>
                <div className="attribute-value-container">
                  <p>{debt}</p>
                </div>
              </div>
              <div className="squad-club-attributes" style={{backgroundColor: assetsLiabilities?.includes("-") ? "#FFC2C2" : "#C9F0B6", border: assetsLiabilities?.includes("-") ? "1px solid #E8B1B1" : "1px solid #B7DAA6"}}>
                <p>ASSET/LIAB</p>
                <div className="attribute-value-container">
                  <p>{assetsLiabilities}</p>
                </div>
              </div>
            </div>
          </PlayerCardFooter>
        </CardInfo>
      </PlayerCard>
    </>
  );
};

export default ClubCard;
